import { render } from "./Dashboard3.vue?vue&type=template&id=6452d30e&scoped=true"
import script from "./Dashboard3.vue?vue&type=script&lang=js"
export * from "./Dashboard3.vue?vue&type=script&lang=js"

import "./Dashboard3.vue?vue&type=style&index=0&id=6452d30e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6452d30e"]])

export default __exports__